<template>
    <form id="DepartamentoSelectForm" @submit.prevent="submit" class="ajax_off">
        <div class="form-group">
            <label>Selecione o departamento</label>
            <e-select name="departamento_id" v-model="selected_departamento_id" route="time" />
        </div>
    </form>
</template>
<script>
export default {
    props: {
        tarefa_id: Number,
        departamento_id: Number,
    },
    data() {
        return {
            selected_departamento_id: null,
        }
    },
    created() {
        this.selected_departamento_id = this.departamento_id;
    },
    methods: {
        async submit() {
            await this.$api.put('tarefa/departamento', {
                tarefa_id: this.tarefa_id,
                departamento_id: this.selected_departamento_id,
            });

            this.$emit('getCartao');
            this.$bvModal.hide('departamento-select')

        }
    }

}
</script>
